import { useEffect } from "react";
import Lenis from "@studio-freight/lenis";

export default function MomentumScrollWrapper({ children }) {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 0.5,       // base scroll momentum
      easing: (t) => t,    // linear easing here; momentum handled by lenis
      smooth: true,        
      direction: "vertical",
      gestureDirection: "vertical",
      infinite: false,
      lerp: 0.09           // lower = more floaty / inertia feel
    });

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    // optional: detect scroll speed
    const handleScroll = () => {
      // you can log lenis.scroll or lenis.velocity for debugging
      // console.log(lenis.velocity);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return <>{children}</>;
}
